import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const PromosList = lazy(() => import('../../container/pages/PromosList'));
const PromosAdd = lazy(() => import('../../container/pages/PromosAdd'));
const PromosEdit = lazy(() => import('../../container/pages/PromosEdit'));

const PromoRoute = () => {
  return (
    <Routes>
      <Route path="list" element={<PromosList />} />
      <Route path="add" element={<PromosAdd />} />
      <Route path="edit/:promoId" element={<PromosEdit />} />
    </Routes>
  );
};

export default PromoRoute;
